import React, { useState, useEffect } from 'react';

const HeroSlider = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds
    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <>
      <style>
        {`
          .ken-burns-enter {
            opacity: 0;
            transform: scale(1.1);
          }
          .ken-burns-enter-active {
            opacity: 1;
            transform: scale(1);
            transition: opacity 3s ease-in-out, transform 5s ease-in-out;
          }
          .ken-burns-exit {
            opacity: 1;
            transform: scale(1);
          }
          .ken-burns-exit-active {
            opacity: 0;
            transform: scale(1.05);
            transition: opacity 3s ease-in-out, transform 5s ease-in-out;
          }
        `}
      </style>
      <div className="relative w-full h-full overflow-hidden">
        {images.map((image, index) => (
          <div
            key={image}
            className={`absolute inset-0 w-full h-full transition-opacity duration-1000 ease-in-out ${index === currentIndex ? 'opacity-100' : 'opacity-0'}`}>
            <div
              className="w-full h-full bg-contain bg-no-repeat bg-center ken-burns-enter-active"
              style={{ backgroundImage: `url(${image})` }}
            ></div>
          </div>
        ))}
      </div>
    </>
  );
};

export default HeroSlider;
